import { writable } from 'svelte/store'

function createToastStore() {
  const { subscribe, update } = writable([])

  function createToast(type, message, description = '', duration = 10000, autoClose = true) {
    const toast = {
      type,
      id: Date.now(),
      message,
      description,
      duration,
      autoClose,
      timeoutId: null,
    }

    if (autoClose) {
      toast.timeoutId = setTimeout(() => {
        destroyToast(toast.id)
      }, duration)
    }
    update(toasts => [...toasts, toast])
    return toast.id
  }

  function destroyToast(id) {
    update(toasts => {
      const toastIndex = toasts.findIndex(toast => toast.id === id)
      if (toastIndex !== -1) {
        clearTimeout(toasts[toastIndex].timeoutId)
      }
      return toasts.filter(toast => toast.id !== id)
    })
  }

  function destroyAllToasts() {
    update(toasts => {
      toasts.forEach(toast => {
        if (toast.timeoutId) {
          clearTimeout(toast.timeoutId)
        }
      })
      return []
    })
  }

  function closeManually(id) {
    destroyToast(id)
  }

  return {
    subscribe,
    createToast,
    destroyToast,
    closeManually,
    destroyAllToasts,
  }
}

export const toastStore = createToastStore()
